import { useState } from "react";

const POSTER = "https://images.unsplash.com/photo-1561501900-3701fa6a0864";
const SOURCES = [
  "https://videos.pexels.com/video-files/2169880/2169880-hd_1920_1080_30fps.mp4",
  "https://videos.pexels.com/video-files/3121459/3121459-hd_1920_1080_24fps.mp4",
  "https://videos.pexels.com/video-files/1526909/1526909-hd_1920_1080_24fps.mp4",
];

export const HeroVideo = () => {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <video autoPlay muted loop playsInline poster={POSTER}
      onError={() => setFailed(true)}
      className="absolute inset-0 w-full h-full object-cover">
      {SOURCES.map((s) => <source key={s} src={s} type="video/mp4" />)}
    </video>
  );
};
